import { render } from "./Univ.vue?vue&type=template&id=f632d91c&scoped=true"
import script from "./Univ.vue?vue&type=script&lang=js"
export * from "./Univ.vue?vue&type=script&lang=js"

import "./Univ.vue?vue&type=style&index=0&id=f632d91c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f632d91c"

export default script